import { Row, Col, Card, Image } from "../../bootstrap.js";
import "./groupMembers.css";
import { useMediaQuery } from "usehooks-ts";

export function Mona({ members }) {
  const isMobile = useMediaQuery("(max-width: 992px)");

  return (
    <section>
      <Row className="group2Row">
        {members.map(
          (member, i) =>
            i > 0 && (
              <div>
                <Col xs={12} sm={12} className="">
                <div className="positionsGroup">
                  <div className="floatImgMonaCont">
                  <Image
                    src={`/images/Group/${member.img}.jpg`}
                    className=" memberPic floatImgMona"
                    alt={`${member.alt}`}
                  ></Image>
                  </div>

                        <h1 className="groupName">{member.name}</h1>

                        <h5 className="groupTitle">{member.title}</h5>
                        <h5 className="groupTitle">
                          Affiliate Faculty, Chemistry and Chemical Biology
                        </h5>
                        <div className="aboveBorder">
                          <Row className="eduspace">
                            <h5 className="education1">{member.education}</h5>
                          </Row>
                        <div className="groupSoc1">
                          
                            <div className="groupSocCont">
                            <a href="https://www.linkedin.com/in/monaminkara/">
                              <i class="bi bi-linkedin"></i>
                            </a>
                            <a href="https://www.youtube.com/channel/UCYBXlV5HoElWXs5zCKNEtaQ">
                              <i class="bi bi-youtube"></i>
                            </a>
                            <a href="https://monaminkara.com/" 
									><Image 
											 src="/images/logo/mmi.png"
											className="mLogo"/></a>
                            </div>
                          </div>
                          </div>
                          <hr className="hrLine"></hr>
                        
                      </div>
                      <div className="researchGroup">
                                    
                                    <p className="researchText">
                                    Dr. Mona Minkara directs the COMBINE (Computational Modeling for Biointerface Engineering) Lab at Northeastern University. The lab studies pulmonary surfactant, the protein-lipid mixture lining the lungs that makes breathing possible and mounts one of the body's first defenses against inhaled pathogens. Since founding the lab in 2019, Minkara has built a research program spanning the full system, from the interfacial biophysics of the alveolar surface to the four surfactant proteins that keep the lung stable. Her current work centers on SP-A and SP-D, the two that are also collectins, and on how they recognize the pathogenic glycans coating viruses, bacteria, fungi, and pollen. Using molecular dynamics, Monte Carlo, and free-energy methods, her group decodes the molecular language these proteins use to communicate. COMBINE is one of a small number of groups worldwide applying these methods to collectin-glycan recognition at this level of detail. Minkara is a blind scientist and the founding director of the Academy of Blind Scientists, and she builds the multisensory computational tools her research depends on.
                                    </p>
                                  </div>  

                      <h5 className="groupTitle">
                        Honors
                        </h5>
                      <div>        
                      <p className="descEd edp">2026 Alfred P. Sloan Research Fellowship </p>
                      <p className="descEd edp">2026 Camille Dreyfus Teacher-Scholar </p>
                      <p className="descEd edp">2026 AFB Migel Medal </p>
                      <p className="descEd edp">2024 NSF CAREER Award </p>
                      <p className="descEd edp">2024 NIH MIRA (R35) </p>
                      <p className="descEd edp">2022 Martin W. Essigmann Outstanding Teaching Award</p>
                      <p className="descEd edp">2019 Holman Prize • 2016 Ford Foundation/NASEM Postdoctoral Fellowship</p>
                      <p className="descEd edp">NSF Graduate Research Fellowship</p> 

                     </div> 
                         
                      <h5 className="groupTitle">
                        Education
                        </h5>
                      <div>        
                      <p className="descEd edp">Postdoctoral Research Associate, Chemical Theory Center, University of Minnesota, 2015–2019 </p>
                      {/* <p className="descEd edp">Advisor: Prof. J. Ilja Siepmann </p> */}

                      {/* <p className="descEd edp">Funded by Ford Foundation National Academies of Sciences, Engineering, and Medicine (NASEM) Postdoctoral Fellowship </p> */}

                      <p className="descEd edp">Ph.D. in Chemistry, Quantum Theory Project, University of Florida, 2015  </p>
                      {/* <p className="descEd edp">Thesis: "Design of a Novel Inhibitor for Helicobacter pylori urease" </p>
                      <p className="descEd edp">Funded by NSF Graduate Research Fellowship </p>
                      <p className="descEd edp">Advisors: Prof. Kenneth M. Merz Jr. & Prof. Erik Deumens</p> */}


                      <p className="descEd edp">B.A. in Chemistry and Middle Eastern Studies, Wellesley College, 2009</p> 
                      {/* <p className="descEd edp">Thesis: "Analyzing the Binding of Nevirapine and Rilpivirine to HIV-1 Reverse Transcriptase through Computationally Derived Charge Optimization"</p> 
                      <p className="descEd edp">Advisor: Prof. Mala Radhakrishnan</p>  */}

                     </div> 
          
                </Col>
              </div>
            )
        )}
      </Row>
    </section>
  );
}
